import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-deezer';
export var ID = 'icon-deezer';
/* eslint-disable max-len */

export var SVGDeezer = function SVGDeezer() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 72 72"
  }, React.createElement("defs", null, React.createElement("polygon", {
    id: "path",
    points: "0.06 0.424 9.354 0.424 9.354 17.998 0.06 17.998"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    fill: "#282828",
    cx: "36",
    cy: "36",
    r: "36"
  }), React.createElement("g", {
    transform: "translate(10.000000, 22.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 10.633000)"
  }, React.createElement("mask", {
    id: "mask",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#path"
  })), React.createElement("polygon", {
    fill: "#D8232A",
    mask: "url(#mask)",
    points: "0.06 17.998 9.354 17.998 9.354 15.163 0.06 15.163"
  }), React.createElement("polygon", {
    fill: "#D8232A",
    mask: "url(#mask)",
    points: "0.06 14.313 9.354 14.313 9.354 11.478 0.06 11.478"
  }), React.createElement("polygon", {
    fill: "#D8232A",
    mask: "url(#mask)",
    points: "0.06 10.629 9.354 10.629 9.354 7.794 0.06 7.794"
  }), React.createElement("polygon", {
    fill: "#EB9073",
    mask: "url(#mask)",
    points: "0.06 6.943 9.354 6.943 9.354 4.109 0.06 4.109"
  }), React.createElement("polygon", {
    fill: "#EB9073",
    mask: "url(#mask)",
    points: "0.06 3.258 9.354 3.258 9.354 0.424 0.06 0.424"
  })), React.createElement("polygon", {
    fill: "#FFF101",
    points: "10.488 28.631 19.842 28.631 19.842 25.796 10.488 25.796"
  }), React.createElement("polygon", {
    fill: "#FFF101",
    points: "10.488 24.946 19.842 24.946 19.842 22.111 10.488 22.111"
  }), React.createElement("polygon", {
    fill: "#FFF101",
    points: "10.488 21.262 19.842 21.262 19.842 18.427 10.488 18.427"
  }), React.createElement("polygon", {
    fill: "#D8127D",
    points: "20.977 28.631 30.331 28.631 30.331 25.796 20.977 25.796"
  }), React.createElement("polygon", {
    fill: "#D8127D",
    points: "20.977 24.946 30.331 24.946 30.331 22.111 20.977 22.111"
  }), React.createElement("polygon", {
    fill: "#D8127D",
    points: "20.977 21.262 30.331 21.262 30.331 18.427 20.977 18.427"
  }), React.createElement("polygon", {
    fill: "#E893B5",
    points: "20.977 17.576 30.331 17.576 30.331 14.742 20.977 14.742"
  }), React.createElement("polygon", {
    fill: "#E893B5",
    points: "20.977 13.891 30.331 13.891 30.331 11.057 20.977 11.057"
  }), React.createElement("polygon", {
    fill: "#E893B5",
    points: "20.977 10.206 30.331 10.206 30.331 7.371 20.977 7.371"
  }), React.createElement("polygon", {
    fill: "#E893B5",
    points: "20.977 6.522 30.331 6.522 30.331 3.687 20.977 3.687"
  }), React.createElement("polygon", {
    fill: "#B9D137",
    points: "31.465 28.631 40.819 28.631 40.819 25.796 31.465 25.796"
  }), React.createElement("polygon", {
    fill: "#B9D137",
    points: "31.465 24.946 40.819 24.946 40.819 22.111 31.465 22.111"
  }), React.createElement("polygon", {
    fill: "#B9D137",
    points: "31.465 21.262 40.819 21.262 40.819 18.427 31.465 18.427"
  }), React.createElement("polygon", {
    fill: "#DAE596",
    points: "31.465 17.576 40.819 17.576 40.819 14.742 31.465 14.742"
  }), React.createElement("polygon", {
    fill: "#DAE596",
    points: "31.465 13.891 40.819 13.891 40.819 11.057 31.465 11.057"
  }), React.createElement("polygon", {
    fill: "#35BCE1",
    points: "41.953 28.631 51.308 28.631 51.308 25.796 41.953 25.796"
  }), React.createElement("polygon", {
    fill: "#35BCE1",
    points: "41.953 24.946 51.308 24.946 51.308 22.111 41.953 22.111"
  }), React.createElement("polygon", {
    fill: "#35BCE1",
    points: "41.953 21.261 51.308 21.261 51.308 18.426 41.953 18.426"
  }), React.createElement("polygon", {
    fill: "#ABDCEC",
    points: "41.953 17.576 51.308 17.576 51.308 14.741 41.953 14.741"
  }), React.createElement("polygon", {
    fill: "#ABDCEC",
    points: "41.953 13.891 51.308 13.891 51.308 11.056 41.953 11.056"
  }), React.createElement("polygon", {
    fill: "#ABDCEC",
    points: "41.953 10.205 51.308 10.205 51.308 7.371 41.953 7.371"
  }), React.createElement("polygon", {
    fill: "#ABDCEC",
    points: "41.953 6.52 51.308 6.52 51.308 3.686 41.953 3.686"
  }), React.createElement("polygon", {
    fill: "#ABDCEC",
    points: "41.953 2.835 51.308 2.835 51.308 0 41.953 0"
  }))));
};
/* eslint-disable max-len */

var Deezer = function Deezer(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGDeezer
  });
};

Deezer.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Deezer;